import { render, staticRenderFns } from "./upgradeContent.vue?vue&type=template&id=1926cdaa&"
import script from "./upgradeContent.vue?vue&type=script&lang=js&"
export * from "./upgradeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1926cdaa')) {
      api.createRecord('1926cdaa', component.options)
    } else {
      api.reload('1926cdaa', component.options)
    }
    module.hot.accept("./upgradeContent.vue?vue&type=template&id=1926cdaa&", function () {
      api.rerender('1926cdaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ota/upgradeContent.vue"
export default component.exports